const CONTACT = {
  MAIL: "mailto:tknox.dr@gmail.com",
  LINKEDIN: "https://www.linkedin.com/in/selaktihomir/",
  GITHUB: "https://github.com/Tihi321"
};

module.exports = {
  CONTACT
};
